import React from 'react';
import type {Collection} from '@shopify/hydrogen/storefront-api-types';
import {useLoaderData, useParams} from '@remix-run/react';
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/dist/ScrollTrigger';
import {useIsHydrated} from '~/hooks/useIsHydrated';

//domains
import {loader} from '~/routes/($lang)/collections/$collectionHandle';

//components
import CollectionBreadcrumb from '~/components/collection/CollectionBreadcrumb';
import CollectionSorting from 'components/collection/CollectionSorting';
import CollectionProducts from 'components/collection/CollectionProducts';
import CollectionPagination from 'components/collection/CollectionPagination';
import CollectionFilter from '~/components/collection/CollectionFilter';
import CollectionMobileFilterAndSort from './CollectionMobileFilterAndSort';
import BrandBreadcrumb from './BrandBreadcrumb';

interface Props {
  type?: string;
}

export default function CollectionMain({type}: Props) {
  const {totalProducts, translation} = useLoaderData<typeof loader>();
  const filterColRef = React.useRef<HTMLDivElement>(null);
  const mainRef = React.useRef<HTMLDivElement>(null);
  const sortingRef = React.useRef<HTMLDivElement>(null);

  //   React.useEffect(() => {
  //     ScrollTrigger.matchMedia({
  //       '(min-width: 1024px)': function () {
  //         if (filterColRef?.current && mainRef?.current) {
  //           gsap.timeline({
  //             scrollTrigger: {
  //               start: 'top 217px',
  //               trigger: filterColRef?.current,
  //               endTrigger: '#email-signup',
  //               end: 'top bottom',
  //               pin: true,
  //               pinSpacing: false,
  //             },
  //           });
  //         }
  //         if (sortingRef?.current && mainRef?.current) {
  //           gsap.timeline({
  //             scrollTrigger: {
  //               start: 'top 181px',
  //               trigger: sortingRef?.current,
  //               endTrigger: '#email-signup',
  //               end: 'top bottom',
  //               pin: true,
  //               pinSpacing: false,
  //             },
  //           });
  //         }
  //       },
  //     });
  //   }, []);
  const isHydrated = useIsHydrated();

  return (
    <div className="grid lg:grid-cols-8 lg:gap-10 lg:pt-10" ref={mainRef}>
      <div className="relative lg:col-span-2 hidden lg:block">
        <div className="relative lg:col-span-2">
          <div className="" ref={filterColRef}>
            <div className="lg:pr-4 lg:pb-64">
              {type === 'brands' ? (
                <BrandBreadcrumb />
              ) : (
                <CollectionBreadcrumb />
              )}
              <div className="hidden lg:block">
                <CollectionFilter />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="lg:col-span-6">
        <div
          ref={sortingRef}
          className="fixed left-1/2 z-[100] md:z-10 md:mt-4 flex flex-col md:flex-row w-screen -translate-x-1/2 items-center justify-between bg-white px-5 mt-0 pt-1 pb-1 md:py-2 lg:relative lg:left-0 lg:mt-0 lg:mb-14 lg:h-14 lg:w-full lg:translate-x-0 lg:bg-hk-orange lg:px-4 mobile-collections-bar translate-y-[-27px]"
        >
          <div className="lg:hidden">
            {type === 'brands' ? <BrandBreadcrumb /> : <CollectionBreadcrumb />}
          </div>
          <div className="text-sm w-full lg:w-auto">
            {translation.product_listing ?? `Product Listing`}: {totalProducts}
          </div>
          <div className="hidden lg:block">
            <CollectionSorting />
          </div>
        </div>
        <div className="fixed left-1/2 mt-[12px] w-screen -translate-x-1/2 px-5 lg:hidden collection-mobile-filter-sort z-[100]">
          {isHydrated && <CollectionMobileFilterAndSort />}
        </div>
        <CollectionProducts />
        <CollectionPagination />
      </div>
    </div>
  );
}
